

/// <reference path="PaymentEntity.ts" />

// Generated class CashOnDeliveryPaymentEntity_ManagedObject

class CashOnDeliveryPaymentEntity_ManagedObject extends PaymentEntity
{
}
